import { render, staticRenderFns } from "./CreateOpenAward.vue?vue&type=template&id=496bf3dc&scoped=true&"
import script from "./CreateOpenAward.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateOpenAward.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CreateOpenAward.vue?vue&type=style&index=0&id=496bf3dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496bf3dc",
  null
  
)

export default component.exports